import {
  APIErrorResponse,
  InternalHoursLog,
  PaginatedListResponse,
  SearchRequestParams,
} from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '@/hooks/api/useQueryList'
import { QUERY_KEYS } from '@/constants'

export const getUseInternalHoursLogsKey = () =>
  QUERY_KEYS.INTERNAL_HOURS_LOGS.slice(0, 2) as string[]

export const useInternalHoursLogs = (
  params: SearchRequestParams = {},
  enabled = true
): UseQueryResult<PaginatedListResponse<InternalHoursLog>, APIErrorResponse> =>
  useQueryList({
    url: '/hours_reporting/internal-hours/',
    key: [...QUERY_KEYS.INTERNAL_HOURS_LOGS, params],
    options: { enabled },
    params,
  })
